import * as React from 'react';
import { Button } from '@bytebrand/fe-ui-core-autobahn/ui';
import styles from './ConfirmCarDeleteModal.styl';
class ConfirmCarDeleteModal extends React.Component {
    render() {
        const { t, onAccept, onDecline } = this.props;
        return (React.createElement("div", { className: styles.confirmCarDeleteModal },
            React.createElement("div", { className: styles.content },
                React.createElement("h4", { className: styles.heading }, t('confirmCarDeleteModal.confirmCarDeleteTitle')),
                React.createElement("p", { className: styles.text }, t('confirmCarDeleteModal.confirmCarDeleteText'))),
            React.createElement("div", { className: styles.controls },
                React.createElement(Button, { className: styles.decline, variant: 'tonal', onClick: onDecline }, t('confirmCarDeleteModal.decline')),
                React.createElement(Button, { className: styles.confirm, variant: 'filled', onClick: onAccept }, t('confirmCarDeleteModal.accept')))));
    }
}
Object.defineProperty(ConfirmCarDeleteModal, "defaultProps", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: {
        onAccept: () => { },
        onDecline: () => { }
    }
});
export default ConfirmCarDeleteModal;
